import { useState } from "react";

const PALETTE = ["#9E1B28", "#C89B3C", "#2E6F6B", "#5B3A8C", "#8C5A2B", "#3A5F8C"];

const initials = (name = "") =>
  name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");

const colorFor = (name = "") => PALETTE[[...name].reduce((a, c) => a + c.charCodeAt(0), 0) % PALETTE.length];

export function ActorAvatar({ name, photoUrl, size = 44, className = "", testId }) {
  const [broken, setBroken] = useState(false);
  const style = { width: size, height: size, fontSize: Math.max(11, size * 0.36) };
  if (photoUrl && !broken) {
    return (
      <img
        src={photoUrl}
        alt={name}
        data-testid={testId}
        style={style}
        onError={() => setBroken(true)}
        className={`shrink-0 rounded-full object-cover ring-2 ring-[hsl(var(--gold))]/40 ${className}`}
      />
    );
  }
  return (
    <span
      data-testid={testId}
      style={{ ...style, background: colorFor(name) }}
      className={`flex shrink-0 items-center justify-center rounded-full font-serif font-semibold text-amber-50 ${className}`}
    >
      {initials(name)}
    </span>
  );
}
